import { CircularProgress } from "@mui/material";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";

const LoadingState = () => {
    return (
        <StackKit alignItems="center" justifyContent="center" sx={{ py: 8 }}>
            <CircularProgress sx={{ color: '#7367F0' }} />
            <TypoGraphyKit sx={{ mt: 2, color: '#A4A4A4' }}>در حال بارگذاری...</TypoGraphyKit>
        </StackKit>
    );
};

export default LoadingState;